import axios, { HttpStatusCode } from "axios";
import i18next from "i18next";
import { LocalStorageKey } from "../shared/enums";
import { isEmpty } from "lodash";
import { toast } from 'react-toastify';
import i18n from "../translations";

var _pendingRequest = [];
const _REQUEST_COOLDOWN = 3000;

async function interceptRequest(requestConfig) {
    const token = localStorage?.getItem(LocalStorageKey.TOKEN)?.replaceAll(`"`, "");

    checkPendingRequest(requestConfig);

    // if (requestConfig.headers.skipLoading === undefined || requestConfig.headers.skipLoading === false) {
    //     store.dispatch(setLoading(1));
    // }

    requestConfig.byPassError = requestConfig.headers.byPassError
    requestConfig.showSuccess = requestConfig.headers.showSuccess

    const currentLanguage = i18next?.language;

    if (!isEmpty(token)) {
        requestConfig.headers.Authorization = "Bearer " + token;
    }

    if (currentLanguage) {
        requestConfig.headers["Accept-Language"] = localStorage.getItem(LocalStorageKey.LANGUAGE);
    }

    requestConfig.cancelToken = new axios.CancelToken((cancel) => {
        _pendingRequest.push({
            url: requestConfig.url,
            removeRequest: cancel,
            requestTime: new Date().getTime(),
        });
    });

    return requestConfig;
}

function interceptResponse(response) {
    _pendingRequest = [];

    if (![HttpStatusCode.Ok, HttpStatusCode.NoContent, HttpStatusCode.Created, HttpStatusCode.Accepted].includes(response.status) && !response.config.byPassError) {
        response.data.success = false
        toast.error(response.data.message)
    } else {
        response.data.success = true
    }

    return response.data;
}

function interceptError(error) {
    let returnData = {};

    if (error.response) {
        if (error?.response.status === HttpStatusCode.Unauthorized) {
            localStorage.removeItem(LocalStorageKey.TOKEN)
        }

        returnData.success = false
        returnData.message = error?.response?.data?.message ?? "Error " + error.response.status + " encounter, please contact admin for help";
    }
    else if (!axios.isCancel(error)) {
        returnData.success = false
        returnData.message = !isEmpty(error.message) ? JSON.stringify(error.message) : "Error " + error.response.status + " encounter, please contact admin for help";
    }
    else {
        returnData.success = false
        returnData.message = "SERVER_IS_PROCESSING";
    }

    if (!error.config.byPassError) {
        toast.error(i18n.t(returnData.message))
    }

    return returnData;
}

const checkPendingRequest = (config) => {
    if (
        _pendingRequest.some(
            (request) =>
                request.url == config.url && request.requestTime < _REQUEST_COOLDOWN
        )
    ) {
        for (
            var i = 0;
            i <
            _pendingRequest.filter(
                (request) =>
                    request.url == config.url && request.requestTime < _REQUEST_COOLDOWN
            ).length;
            i++
        ) {
            _pendingRequest[i].removeRequest();
        }
    }
};

const ApiBase = axios.create({
    baseURL: process.env.REACT_APP_API_URL + "/v1",
    headers: {
        ['x-app-id']: process.env.REACT_APP_ID
    },
    timeout: 60000
});

ApiBase.interceptors.request.use(
    (config) => interceptRequest(config),
    (error) => interceptError(error)
);

ApiBase.interceptors.response.use(
    (response) => interceptResponse(response),
    (error) => interceptError(error)
);

export default ApiBase;
